import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'viva-wallet',
        component: () => import('../views/VivaWallet')
    },
    {
        path: '/success',
        name: 'viva-wallet-success',
        component: () => import('../views/VivaWalletSuccess')
    },
    {
        path: '/failure',
        name: 'viva-wallet-failure',
        component: () => import('../views/VivaWalletFailure')
    },
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
